import { render, staticRenderFns } from "./account.vue?vue&type=template&id=eb4135f6&scoped=true"
import script from "./account.vue?vue&type=script&lang=ts"
export * from "./account.vue?vue&type=script&lang=ts"
import style0 from "./account.vue?vue&type=style&index=0&id=eb4135f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb4135f6",
  null
  
)

export default component.exports